import { Injectable } from '@angular/core';
import cloneDeep from 'lodash/cloneDeep';
@Injectable({
  providedIn: 'root'
})
export class UndoService {
  /** Undo details storage*/
  undos = [];
  /** current visible undo position, for allowing multiple undo/redos*/
  undoLevel = 0;
  /** Item undo list is referencing*/
  itemObject;
  /** Key that data is stored in*/
  holder;
  constructor() { }

  setup(items, holder) {
    setTimeout(() => {
      this.itemObject = items;
      this.holder = holder;
      this.clear();
      console.log(this.itemObject);
    });
  }
  /**
   * Trigger and undo
   * @param i undo index to trigger
   */
  undo(i?) {
    if (i !== undefined) {
      this.undoLevel = i;
      this.itemObject[this.holder] = cloneDeep(this.undos[i]);
    } else {
      if (this.undoLevel > 0) {
        this.undoLevel--;
        this.itemObject[this.holder] = cloneDeep(this.undos[this.undoLevel]);
        console.log('undo ', this.undos[this.undoLevel]);
      }
    }
  }
  /**Trigger a redo */
  redo() {
    if (this.undoLevel < this.undos.length - 1) {
      this.undoLevel++;
      this.itemObject[this.holder] = cloneDeep(this.undos[this.undoLevel]);
    }
  }
  /**Clear undo data */
  clear() {
    this.undos = [cloneDeep(this.itemObject[this.holder])];
    this.undoLevel = 0;
  }
  /**Add a level to the undo list*/
  addUndo() {
    if (this.undoLevel + 1 < this.undos.length) {
      this.undos.splice(this.undoLevel + 1, this.undos.length);
    }
    this.undos.push(cloneDeep(this.itemObject[this.holder]));
    this.undoLevel = this.undos.length - 1;
  }
}
